module.exports = __webpack_public_path__ + "img/icon2.ac2e5b33.png";